import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import FaqSectionMasterModalPage from '../../../containers/masters/FaqSection/FaqSectionMasterModalPage'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class FaqSectionMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchUO: null,
        searchTitle: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchFaqSectionTable()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchFaqSectionTable({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchFaqSectionTable({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleOrganizedUnitChange (filterUO) {
    if (!filterUO || filterUO.length === 0) {
      this.setState({ filter: { ...this.state.filter, searchUO: [] } })
    } else {
      const searchUoList = filterUO.split(',').map((item) => {
        return parseInt(item)
      })
      if (this.state.filter.searchUO !== searchUoList) {
        this.setState({ filter: { ...this.state.filter, searchUO: searchUoList } })
      }
    }
  }

  handleTitleChange (filterText) {
    if (this.state.filter.searchTitle !== filterText) {
      this.setState({ filter: { ...this.state.filter, searchTitle: filterText } })
    }
  }

  btnSearchEventHandler () {
    const filter = { ...this.props.filter, ...this.state.filter, page: 1 }
    this.props.actions.fetchFaqSectionTable(filter)
  }

  resetFilters () {
    this.setState({
      filter: {
        searchUO: null,
        searchTitle: null
      }
    }, () => { this.btnSearchEventHandler() })
  }

  render () {
    const {
      t, faqSections, pagesCount, sectionsCount, filter,
      filter: { page },
      combos: { UOTreeCombo },
      actions: { deleteFaqSection, fetchFaqSection, recoverFaqSection, fetchFaqSectionTable }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'faqSectionMastersPage' })
    const tKey = 'MASTERS'
    const tFaqSection = 'FAQSECTION'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}.EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}.DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t(`${tKey}.RECOVER`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchTitle || this.state.filter.searchUO)

    return (
      <div id='faqSectionMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button className="_Btn new" onClick={() => fetchFaqSection()}>
              <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputTreeSelect}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.organizedUnitCombo"
                controlLabel={t(`${tKey}.${tFaqSection}.ORGANIZED_UNIT`)}
                placeholder={t(`${tKey}.${tFaqSection}.ORGANIZED_UNIT`)}
                multi={true}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                options={UOTreeCombo}
                onInputChange={(value) => this.handleOrganizedUnitChange(value)}
                showSearch={false}
              />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.title"
                controlLabel={t(`${tKey}.${tFaqSection}.TITLE_FIELD`)}
                placeholder={t(`${tKey}.${tFaqSection}.TITLE_FIELD`)}
                onInputChange={(value) => this.handleTitleChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.btnSearchEventHandler()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}.SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t(`${tKey}.RESET_BUTTON`)}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              { faqSections.length !== 0 &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('organizedUnitName') }}>
                        {t(`${tKey}.${tFaqSection}.ORGANIZED_UNIT`)} <i className={this.getSortIcon('organizedUnitName')} />
                      </th>
                      <th onClick={() => { this.changeOrder('title') }}>
                        {t(`${tKey}.${tFaqSection}.TITLE_FIELD`)} <i className={this.getSortIcon('title')} />
                      </th>
                      <th onClick={() => { this.changeOrder('description') }}>
                        {t(`${tKey}.${tFaqSection}.SECTION_FIELD`)} <i className={this.getSortIcon('description')} />
                      </th>
                      <th className='actions'>
                        {t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {faqSections && faqSections.map((faqSection, idx) => (
                      <tr key={idx} className={faqSection.disabled ? 'is-deleted' : '' }>
                        <td>{faqSection.organizedUnitName}</td>
                        <td>{faqSection.title}</td>
                        <td>{faqSection.description}</td>
                        <td className='actions'>
                          {!faqSection.disabled ? (
                            <div>
                              <OverlayTrigger placement="left" overlay={editTooltip}>
                                <a className='_Btn accept stk o-icn ' onClick={() => fetchFaqSection(faqSection.faqSectionId)}>
                                  <i className="iDocIcon-edit" />
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                <a className='_Btn cancel stk o-icn ' onClick={() => deleteFaqSection(faqSection.faqSectionId)}>
                                  <i className="iDocIcon-delete-forever" />
                                </a>
                              </OverlayTrigger>
                            </div>
                          ) : (
                            <div>
                              <OverlayTrigger placement="left" overlay={recoverTooltip}>
                                <a className='_Btn accent stk o-icn ' onClick={() => recoverFaqSection(faqSection.faqSectionId)}>
                                  <i className='iDocIcon-undo-back' />
                                </a>
                              </OverlayTrigger>
                            </div>

                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              }
              {(faqSections === null || faqSections === undefined || faqSections.length === 0) &&
                <p className="no_results" >{t(`${tKey}.${tFaqSection}.RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-faqsectionmaster-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination id="btn_pag_faqsectionmaster" page={page} pagesCount={pagesCount} totalRows={sectionsCount}
                    onSelectAction={(value) => fetchFaqSectionTable({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <FaqSectionMasterModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listFaqSectionMaster'
})(FaqSectionMaster)
